import * as Yup from 'yup';
import { Text } from '@yoweb/ui/components/typography';
import { Grid } from '@yoweb/ui/components/Grid';
import Checkbox from './Checkbox';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var getBooleanInitialValues = function getBooleanInitialValues(booleanAnswer) {
  var _booleanAnswer$answer;

  return (booleanAnswer === null || booleanAnswer === void 0 ? void 0 : (_booleanAnswer$answer = booleanAnswer.answeredValue) === null || _booleanAnswer$answer === void 0 ? void 0 : _booleanAnswer$answer.value) || false;
};
export var getBooleanValidationSchema = function getBooleanValidationSchema(_isOptional) {
  return (// TODO: when isOptional is supported revert to bellow.
    // It currently breaks the validation hack that was implemented to match Azalea functionality
    //isOptional ? Yup.boolean() : Yup.boolean().oneOf([true]);
    Yup["boolean"]().oneOf([true])
  );
};
export var BooleanElement = function BooleanElement(_ref) {
  var instructionHint = _ref.instructionHint,
      booleanAnswer = _ref.booleanAnswer,
      isDisabled = _ref.isDisabled,
      id = _ref.id;
  return /*#__PURE__*/_jsxs(Grid, {
    rowGap: "small2",
    children: [instructionHint && /*#__PURE__*/_jsx(Text, {
      size: "md",
      children: instructionHint
    }), /*#__PURE__*/_jsx(Checkbox, {
      id: id,
      name: id,
      disabled: isDisabled,
      children: booleanAnswer === null || booleanAnswer === void 0 ? void 0 : booleanAnswer.inputFieldHint
    })]
  });
};